// Ads 命名空间扩展片段（广告账户页：分组标签 + 禁用原因副行）。zh/en 同文件。
// 注：ads 命名空间主体仍内联在 locales/zh.js / locales/en.js（本文件只承载新增键，
// 避免整段搬迁）；注册方式——zh.js 顶部 `import adsExtra from './views/ads'`，
// 并在 `ads: {` 花括号内首行插入 `...adsExtra.zh,`（en.js 同理用 adsExtra.en）。
// 新键与内联键无重名，先注册先被内联键覆盖也不会冲突（取并集）。
export default {
  zh: {
    noOwnerTip: '无归属人（导入时未指定）',
    ownerChipTip: '归属人：{email}',
    groupCol: '分组',
    groupAll: '全部分组',
    ownerAll: '全部归属人',
    ownerFilterTip: '按归属人筛选账户（选项=当前账户的归属人）',
    groupFilterTip: '按分组筛选账户（选项=当前账户用到的分组）',
    groupSortTip: '点击按分组聚合（同组相邻，无分组沉底）；再点恢复默认排序',
    groupEditTitle: '设置分组',
    groupBatchTitle: '批量设置分组（{n} 个账户）',
    groupBatchNote: '将为选中的全部账户设置同一分组标签；留空并保存 = 清除分组。',
    groupPh: '如：主投组 / 测试组（留空=清除）',
    groupSet: '设分组',
    groupSaved: '已更新 {n} 个账户的分组',
    groupClearConfirm: '即将清除 {n} 个账户的分组标签（留空保存=清除）。确认清除？',
    drPrefix: '原因：',
    throttledLine: '⏳ 令牌限流中 · 约 {n} 分钟后自动恢复',
    tokenDeadLine: '⚠ 令牌已失效，重新授权',
    noTokenTag: '无令牌',
    idImportHint: '每行一个账户 ID（可带 act_ 前缀，仅支持 Facebook）。无投放权限的账户会被拒绝并提示。',
    readonlyTag: '只读', readonlyTip: '令牌只有查看权限——无法投放/保活，请在 Facebook 商务管理平台（BM）为令牌补「广告投放」权限',
    noTokenTip: '令牌已移除/未绑定：巡检与部署不可用。请到令牌页绑定，或移除纳管。',
    healthTitle: '资产健康',
    healthDisabled: '状态停用', healthToken: '令牌异常', healthAuth: '授权缺失', healthBalance: '余额不足',
    totalAccounts: '账户总数', healthyAccounts: '健康', attentionAccounts: '需关注',
    ownerTransfer: '转移归属',
    ownerEditTitle: '转移账户归属', ownerBatchTitle: '批量转移归属（{n} 个账户）',
    benefEditTitle: '认证受益人 ID', benefUniversal: '通用认证 ID（US/EU/全球）',
    benefUniversalHint: 'VOLUNTARY_VERIFICATION 路径用（BM 认证 ID，多账户可相同）',
    benefSg: '新加坡认证 ID', benefSgHint: 'SINGAPORE_UNIVERSAL 专用——每个账户各不相同（账户本人的验证档案）',
    benefTw: '台湾认证 ID',
    benefPriorityHint: '部署时优先级：账户认证 ID > 投放模板组级 > 模板级；须为纯数字 ID',
    benefDigitOnly: '{k} 认证 ID 须为 10-20 位纯数字',
    ownerTargetPh: '选择目标归属人', ownerTargetRequired: '请选择目标归属人',
    ownerTransferred: '已转移 {n} 个账户归属',
    ownerChipTransferTip: '点击转移归属人',
    exportAccounts: '导出', ownershipLog: '归属流水',
    ownershipLogTitle: '归属变更流水', ownershipLogBy: '操作人',
    ownershipLogEmpty: '暂无归属变更记录',
    openAccountDetail: '查看账户详情',
    currency: '币种', timezone: '时区',
    spendTrend: '近 30 天消耗', spendTrendTotal: '近 {n} 天合计 ${total}', spendTrendEmpty: '暂无消耗数据',
  },
  en: {
    noOwnerTip: 'No owner (not specified at import)',
    ownerChipTip: 'Owner: {email}',
    groupCol: 'Group',
    groupAll: 'All groups',
    ownerAll: 'All owners',
    ownerFilterTip: 'Filter accounts by owner (options come from owners in use)',
    groupFilterTip: 'Filter accounts by group (options come from groups in use)',
    groupSortTip: 'Click to cluster rows by group (ungrouped sink to bottom); click again to restore default order',
    groupEditTitle: 'Set group',
    groupBatchTitle: 'Set group for {n} accounts',
    groupBatchNote: 'Applies one group label to all selected accounts; saving with empty input clears the group.',
    groupPh: 'e.g. Main / Test (empty = clear)',
    groupSet: 'Set group',
    groupSaved: 'Group updated for {n} account(s)',
    groupClearConfirm: 'This will clear the group label of {n} account(s) (saving empty = clear). Confirm?',
    drPrefix: 'Reason: ',
    throttledLine: '⏳ Token rate-limited · auto-recovers in ~{n} min',
    tokenDeadLine: '⚠ Token expired, re-authorize',
    noTokenTag: 'No token',
    idImportHint: 'One account ID per line (act_ prefix optional, Facebook only). Accounts without ad permission will be rejected with a notice.',
    readonlyTag: 'Read-only', readonlyTip: 'Token has view access only — cannot deploy/keep-alive; grant the token the ad role in Facebook Business Manager',
    noTokenTip: 'Token removed/not bound: patrol and deploy are unavailable. Bind a token on the Tokens page, or remove this account from management.',
    healthTitle: 'Asset Health',
    healthDisabled: 'Disabled', healthToken: 'Token issue', healthAuth: 'No write access', healthBalance: 'Low balance',
    totalAccounts: 'Total accounts', healthyAccounts: 'Healthy', attentionAccounts: 'Needs attention',
    ownerTransfer: 'Transfer owner',
    ownerEditTitle: 'Transfer account owner', ownerBatchTitle: 'Transfer owner for {n} accounts',
    benefEditTitle: 'Verified beneficiary IDs', benefUniversal: 'Universal ID (US/EU/Global)',
    benefUniversalHint: 'Used by the VOLUNTARY_VERIFICATION path (BM verified ID, may be shared across accounts)',
    benefSg: 'Singapore ID', benefSgHint: 'For SINGAPORE_UNIVERSAL — unique per account (its own verified profile)',
    benefTw: 'Taiwan ID',
    benefPriorityHint: 'Deploy priority: account IDs > ad-template group > template; digits only',
    benefDigitOnly: '{k} ID must be 10-20 digits',
    ownerTargetPh: 'Select target owner', ownerTargetRequired: 'Select a target owner',
    ownerTransferred: 'Owner transferred for {n} account(s)',
    ownerChipTransferTip: 'Click to transfer owner',
    exportAccounts: 'Export', ownershipLog: 'Ownership log',
    ownershipLogTitle: 'Ownership change log', ownershipLogBy: 'by',
    ownershipLogEmpty: 'No ownership changes yet',
    openAccountDetail: 'View account details',
    currency: 'Currency', timezone: 'Timezone',
    spendTrend: 'Spend (last 30 days)', spendTrendTotal: 'Last {n} days total ${total}', spendTrendEmpty: 'No spend data yet',
  },
}
